import fp from 'lodash/fp';
import { createSelector } from 'reselect';
import toArrayWithQuantity from '../../../../helpers/toArrayWithQuantity';

export const getInventoryPackage = fp.get('inventory.package');

export const getAll = createSelector(getInventoryPackage, fp.get('all'));

export const getAllValues = createSelector(getAll, toArrayWithQuantity);

export const getPackageForId = createSelector((_, id) => id, getAll, fp.get);

export const getIsFetching = createSelector(
  getInventoryPackage,
  fp.get('fetching')
);
export const getIsFetched = createSelector(
  getInventoryPackage,
  fp.get('fetched')
);
export const getFetchingError = createSelector(
  getInventoryPackage,
  fp.get('fetchingError')
);

export const getIsSaving = createSelector(
  getInventoryPackage,
  fp.get('saving')
);
export const getIsSaved = createSelector(getInventoryPackage, fp.get('saved'));
export const getSavingError = createSelector(
  getInventoryPackage,
  fp.get('savingError')
);

export const getIsDeleting = createSelector(
  getInventoryPackage,
  fp.get('deleting')
);
export const getIsDeleted = createSelector(
  getInventoryPackage,
  fp.get('deleted')
);
export const getDeletingError = createSelector(
  getInventoryPackage,
  fp.get('deletingError')
);

export const getOrder = createSelector(getInventoryPackage, fp.get('order'));
